import { render, staticRenderFns } from "./ModalImportarGrupo.vue?vue&type=template&id=047ff25a"
import script from "./ModalImportarGrupo.vue?vue&type=script&lang=js"
export * from "./ModalImportarGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports